import NewMemberCount from 'routes/NewMemberAnalytics/NewMemberCount/NewMemberCount';

export default NewMemberCount;
